import { ReactElement, useState } from "react";
import "../../css/TeeStyles.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import axios from "axios";
import { convertTo12Hour } from "../smallComponents/listIconText";

type ValuePiece = Date | string | null;

interface options {
  weekday: string;
  year: number;
  month: string;
  day: number;
  hour: number;
  minute: number;
  second: number;
  hour12: boolean;
}

type Value = ValuePiece | [ValuePiece, ValuePiece];

const SectionTwo = (): ReactElement => {
  const [values, onChange] = useState<Value>(new Date());
  const [timeValue, setTimeValue] = useState<string>("9:10 AM");
  const [loading, setLoading] = useState<boolean>(false);

  const [success, setSuccess] = useState({
    status: false,
    message: "",
  });
  const [formData, setFormData] = useState({
    "event-type": "",
    calendar: values,
    time: "",
    "full-name": "",
    email: "",
    telephone: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    "event-type": "",
    calendar: "",
    time: "",
    "full-name": "",
    email: "",
    telephone: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleChangeTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setTimeValue(e.target.value);
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let valid = true;

    let newErrors = {
      "event-type": "",
      calendar: "",
      time: "",
      "full-name": "",
      email: "",
      telephone: "",
      message: "",
    };

    if (!formData["event-type"]) {
      valid = false;
      newErrors["event-type"] = "event type is required";
    }

    // if (!formData.calendar) {
    //   valid = false;
    //   newErrors.calendar = "calendar is required";
    // }

    if (!formData.time) {
      valid = false;
      newErrors.time = "Time is required";
    }

    if (!formData.email) {
      valid = false;
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      valid = false;
      newErrors.email = "Invalid email address";
    }

    if (!formData["full-name"]) {
      valid = false;
      newErrors["full-name"] = "Full name is required";
    }

    if (!formData.telephone) {
      valid = false;
      newErrors.telephone = "Telephone field is required";
    }

    if (!formData.message) {
      valid = false;
      newErrors.message = "Message field is required";
    }

    // if (formData.time) {
    //   setTimeValue(formData.time);
    // }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (validate()) {
        setLoading(true);
        // console.log(formData);

        const response = await axios.post(
          "https://jobslounge.markcalthers.com/api/submit-form",
          formData
        );
        // console.log("Form submitted:", formData, response.data);

        if (response.data.status) {
          setSuccess({
            status: true,
            message: "Success! Your event has been created successfully.",
          });
          setLoading(false);
        } else {
          setSuccess({
            status: false,
            message: "Error: Something went wrong. Please try again.",
          });
          setLoading(false);
        }
        setTimeout(() => {
          setSuccess({
            status: false,
            message: "",
          });
        }, 3000);
        // console.log(formData);
      }
    } catch (error) {
      setSuccess({
        status: false,
        message: "Error: Something went wrong. Please try again.",
      });
      setTimeout(() => {
        setSuccess({
          status: false,
          message: "",
        });
      }, 3000);
      setLoading(false);
      //   console.log(error);
    }
  };

  const date = new Date(`${values}`);

  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour12: true,
  };
  const humanReadableCustom = date.toLocaleString("en-US", options);

  return (
    <div data-aos="fade-up" className=" bg-bookings p-md-4 p-3">
      <form onSubmit={handleSubmit}>
        <div className="bgWhite section">
          <div className="py-md-5 py-4 wid80 wid50Mobile mx-auto">
            <div className="form-div">
              <label
                htmlFor="event"
                className="blackKsb fontSize24px mb-3 boldSix"
              >
                Event type
              </label>
              <select
                name="event-type"
                id="event"
                style={{ outline: "none" }}
                value={formData["event-type"]}
                onChange={handleChange}
                className="fontSize20px boldThree rounded-3 mcm-input blackKsb d-block p-3 wid100"
              >
                <option value="" className="p-3">
                  Pick an event option
                </option>
                <option value="Seminars" className="p-3">
                  Seminars
                </option>
                <option value="Video Production" className="p-3">
                  Video Production
                </option>
                <option value="Podcasts" className="p-3">
                  Podcasts
                </option>
                <option value="Photography" className="p-3">
                  Photography
                </option>
              </select>
              {errors["event-type"] && (
                <span className="error d-block red fontSize14px">
                  {errors["event-type"]}
                </span>
              )}
            </div>
            <div className="d-flex flex-wrap wid100 mt-4">
              <div className="form-div wid70 wid100Mobile">
                <label
                  htmlFor="calendar"
                  className="blackKsb fontSize24px mb-3 boldSix"
                >
                  Date & Time
                </label>
                <Calendar
                  onChange={onChange}
                  onClickDay={() => {
                    // console.log(values);
                    setFormData({ ...formData, calendar: `${values}` });
                  }}
                  value={formData.calendar}
                />
                <input
                  type="hidden"
                  name="calendar"
                  //   value={formData.calendar}
                  //   onChange={handleChange}
                  id="calendar"
                />
                {/* {errors["calendar"] && (
                  <span className="error d-block red fontSize14px">
                    {errors["calendar"]}
                  </span>
                )} */}
              </div>
              <div className="form-div wid30 wid100Mobile mt-md-0 mt-3">
                <label
                  htmlFor="time"
                  className="blackKsb fontSize24px d-block mb-3 boldSix"
                >
                  Pick your preferred time
                </label>
                <input
                  type="time"
                  name="time"
                  id="time"
                  style={{ outline: "none" }}
                  value={formData.time}
                  onChange={handleChangeTime}
                  className="fontSize16px wid50 boldThree rounded-3 mcm-input blackKsb d-block p-1 wid100"
                />
                {errors["time"] && (
                  <span className="error d-block red fontSize14px">
                    {errors["time"]}
                  </span>
                )}
              </div>
            </div>
            <span className="fontSize20px mt-3 d-block blackKsb boldFour mb-5">
              You have booked
              <span className="boldEight"> {humanReadableCustom} </span>
              as your desired date and
              <span className="boldEight"> {convertTo12Hour(timeValue)} </span>
              as you start time
            </span>
            <span className="boldSeven blackKsb fontSize32px">Client Info</span>
            <div className="d-flex flex-wrap justify-content-between wid100 mt-3">
              <div className="form-div wid40 wid100Mobile">
                <label
                  htmlFor="full-name"
                  className="blackKsb fontSize24px mb-3 boldSix"
                >
                  Full Name
                </label>
                <input
                  name="full-name"
                  id="full-name"
                  placeholder="John Doe"
                  value={formData["full-name"]}
                  onChange={handleChange}
                  style={{ outline: "none" }}
                  className="fontSize20px boldThree rounded-3 mcm-input blackKsb d-block p-md-3 p-2 wid100"
                />
                {errors["full-name"] && (
                  <span className="error d-block red fontSize14px">
                    {errors["full-name"]}
                  </span>
                )}
              </div>
              <div className="form-div wid40 wid100Mobile mt-md-0 mt-4">
                <label
                  htmlFor="email"
                  className="blackKsb fontSize24px mb-3 boldSix"
                >
                  Email Address
                </label>
                <input
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter a valid Email"
                  style={{ outline: "none" }}
                  className="fontSize20px boldThree rounded-3 mcm-input blackKsb d-block p-md-3 p-2 wid100"
                />
                {errors.email && (
                  <span className="error d-block red fontSize14px">
                    {errors.email}
                  </span>
                )}
              </div>

              <div className="form-div wid40 mt-5 wid100Mobile mt-md-5">
                <label
                  htmlFor="telephone"
                  className="blackKsb fontSize24px mb-3 boldSix"
                >
                  Telephone Number
                </label>
                <input
                  name="telephone"
                  id="telephone"
                  placeholder="+234 801 234 5678"
                  value={formData.telephone}
                  onChange={handleChange}
                  style={{ outline: "none" }}
                  className="fontSize20px boldThree rounded-3 mcm-input blackKsb d-block p-md-3 p-2 wid100"
                />
                {errors.telephone && (
                  <span className="error d-block red fontSize14px">
                    {errors.telephone}
                  </span>
                )}
              </div>
            </div>
            <div className="form-div mt-5 mb-5">
              <label
                htmlFor="message"
                className="blackKsb fontSize24px mb-3 boldSix"
              >
                Special Requirements or Comments
              </label>
              <textarea
                name="message"
                id="message"
                style={{ outline: "none" }}
                value={formData.message}
                onChange={handleChange}
                placeholder="Type your request/comment here..."
                rows={6}
                className="fontSize20px boldThree rounded-3 mcm-input blackKsb d-block p-md-3 p-2 wid100"
              ></textarea>
              {errors.message && (
                <span className="error d-block red fontSize14px">
                  {errors.message}
                </span>
              )}
            </div>
            {/* {success.status && ( */}
            <span
              className={`error text-center d-block mx-auto ${
                success.status ? "green" : "red fontSize14px"
              }`}
            >
              {success.message}
            </span>
            {/* )} */}
            <button className="mx-auto d-block borderNone wid20 wid30Mobile boldSix rounded-2 py-md-2 py-1 px-md-4 px-2 fontSize24px white bgBlackKsb">
              {loading ? "Booking..." : "Book Now"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SectionTwo;
